import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import classes from '../updater.module.css';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { convertToDate, serializeDate } from 'utils';

function UpdateDateField({
    field,
    initialValue,
    onChange
}) {
    const firstInitialValue = useRef(convertToDate(initialValue));
    const [error, setError] = useState();
    const [value, setValue] = useState(firstInitialValue.current);

    useEffect(() => {
        if (firstInitialValue.current) {
            validate(firstInitialValue.current);
        }
    }, []);

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
                id={`update-field__${field}`}
                variant="inline"
                label={field}
                error={!!error}
                helperText={error}
                disablePast
                InputProps={{ className: classes['form-input'] }}
                autoOk
                format="dd/MM/yyyy"
                value={value || null}
                onChange={handleValueChange}
            />
        </MuiPickersUtilsProvider>
    );

    function handleValueChange(val) {
        if (!val) {
            onChange(null);
            return;
        }

        val.setHours(0, 0, 0, 0);
        setValue(val);
        if (validate(val)) {
            onChange(serializeDate(val));
        } else {
            onChange(null);
        }
    }

    function validate(val) {
        let err = null;
        if (val) {
            if (isNaN(val)) {
                err = 'Must be a valid date';
            } else if (val < new Date().setHours(0, 0, 0, 0)) {
                err = 'Must not be in the past';
            }
        } else {
            err = 'Required';
        }

        setError(err);
        return err === null;
    }
}

UpdateDateField.propTypes = {
    field: PropTypes.string.isRequired,
    initialValue: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any,
};

export default UpdateDateField;
